import { matchVersion } from '../../utils';
import isAndroid from '../os/android';
import __regexp from './__firefox-regexp';
/** Detect Mozilla Firefox Android Browser version */
export default function isFirefoxAndroidVersion(operator, version) {
	return function (ua) {
		return (
			isAndroid(ua) &&
			matchVersion({
				ua: ua,
				version: version,
				operator: operator,
				regExp: __regexp,
				groupIndex: 1
			})
		);
	};
}
